class WLSFlickitySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('.js-wls-slider');
    this.id = this.dataset.id;

    if (!this.slider || !this.id) return;

    this.settings = this.getSettings();
    this.currentBp = null;
    this.onSelect = () => this.updateNavButtons();

    this.init();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  getSettings() {
    const el = document.getElementById(`SliderSettings-${this.id}`);
    if (!el) return null;
    return JSON.parse(el.textContent);
  }

  getBreakpoint() {
    const width = window.innerWidth;
    if (width >= 1024) return 'desktop';
    if (width >= 768) return 'tablet';
    return 'base';
  }

  init() {
    if (!this.settings) return;

    const bp = this.getBreakpoint();
    const slidesEls = this.slider.querySelectorAll('.wls-slide');
    const slides = slidesEls.length;

    // Parsing values
    const slidesPerView = Number(this.settings.slidesPerView[bp]);
    const loop = this.settings.loop[bp] === true || this.settings.loop[bp] === "true";
    const navigation = this.settings.navigation[bp] === true || this.settings.navigation[bp] === "true";
    const pagination = this.settings.pagination[bp] === true || this.settings.pagination[bp] === "true";
    const centered = this.settings.centeredSlides[bp] === true || this.settings.centeredSlides[bp] === "true";
    const gap = Number(this.settings.spaceBetween[bp]) || 0;
    this.slider.style.setProperty('--wls-disabled-slider-gap', `${gap}px`);
    this.slider.style.setProperty('--wls-disabled-slider-columns', `${slidesPerView}`);

    // Width and gap
    const slideWidth = `${100 / slidesPerView}%`;
    slidesEls.forEach((slide, index) => {
      slide.style.width = slideWidth;
      slide.style.marginRight = `${gap}px`;

      if (!loop && index === slidesEls.length - 1) {
        slide.style.marginRight = '0';
      }
      
    });


    // Static / disable slider logic
    const shouldDisable = slides <= Math.ceil(slidesPerView);

    if (this.flkty) {
      this.flkty.off('select', this.onSelect);
      this.flkty.destroy();
      this.flkty = null;
    }

    this.isLoop = loop;

    if (shouldDisable) {
      this.classList.add('is-static');
      this.bindNavigation(true);
      slidesEls.forEach(slide => {
        slide.style.marginRight = '0';
      });
      return;
    }

    this.classList.remove('is-static');

    // FLICKITY INIT
    this.flkty = new Flickity(this.slider, {
      cellAlign: centered ? 'center' : 'left',
      contain: true,
      wrapAround: loop && !shouldDisable,
      prevNextButtons: navigation,
      pageDots: pagination,
      draggable: true,
      groupCells: 1
    });

    if (pagination) {
      const dots = this.slider.querySelector('.flickity-page-dots');
      const nav = this.querySelector('.wls-slider__navigation');

      if (dots && nav) {
        nav.insertBefore(dots, nav.querySelector('.js-wls-slider-next'));
      }
    }

    this.flkty.on('select', this.onSelect);
    this.updateNavButtons();
    this.bindNavigation(false);
  }

  updateNavButtons() {
    const prevBtn = this.querySelector('.js-wls-slider-prev');
    const nextBtn = this.querySelector('.js-wls-slider-next');

    if (!prevBtn || !nextBtn) return;

    if (!this.flkty || this.isLoop) {
      prevBtn.disabled = false;
      nextBtn.disabled = false;
      return;
    }

    const index = this.flkty.selectedIndex;
    const lastIndex = this.flkty.slides.length - 1;

    prevBtn.disabled = index === 0;
    nextBtn.disabled = index >= lastIndex;
  }

  bindNavigation(disabled) {
    const prevBtn = this.querySelector('.js-wls-slider-prev');
    const nextBtn = this.querySelector('.js-wls-slider-next');

    if (!prevBtn || !nextBtn) return;

    prevBtn.onclick = null;
    nextBtn.onclick = null;

    if (disabled || !this.flkty) return;

    prevBtn.onclick = () => {
      if (!prevBtn.disabled) this.flkty.previous();
    };
    nextBtn.onclick = () => {
      if (!nextBtn.disabled) this.flkty.next();
    };
  }

  handleResize() {
    const newBp = this.getBreakpoint();

    if (this.currentBp === newBp) return;
    this.currentBp = newBp;

    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.init();
    }, 150);
  }
}

customElements.define('wls-flickity-slider', WLSFlickitySlider);